<iui-messages #messages class="ms-auto me-auto"> </iui-messages>

<div *ngIf="order">

  <div class="float-end">
    <button class="btn btn-primary ms-3" (click)="printInvoice()">Print Statement</button>
    <button class="btn btn-primary ms-3" (click)="downloadPdf()">Download Statement</button>
  </div>

  <h2 class="col-md-4"> Statement {{ orderId }} </h2>

  <div class="mt-5 row">
    <div class="col-md-3">
      <h3 i18n class="mb-3">Customer</h3>
      <div class="truncate" tooltipPosition="top" [pTooltip]="order.company || ''" appShowToolTipIfTruncated>{{ order.company }}</div>
      <div>{{ order.billingFirstName }} {{ order.billingLastName }}</div>
      <div class="truncate" tooltipPosition="top" [pTooltip]="order.billingAddress1 || ''" appShowToolTipIfTruncated>{{ order.billingAddress1 }}</div>
      <div *ngIf="order.billingAddress2" class="truncate" tooltipPosition="top" [pTooltip]="order.billingAddress2 || ''" appShowToolTipIfTruncated>{{ order.billingAddress2
        }}</div>
      <div>{{ order.billingCity }}<span *ngIf="order.billingState">,</span> {{ order.billingState }} {{ order.billingZip }}</div>
      <div>{{ order.billingCountry | scrConfig:'country' }}</div>
    </div>
    <div class="col-md-3">
      <h3 class="mb-3">Details</h3>
      <div><strong>Order ID</strong>: {{ orderId }}<span *ngIf="(order.invoiceVersion || 0) &gt; 1">, Revision: {{ order.invoiceVersion }}</span></div>
      <div><strong>Statement Date</strong>: {{ order.invoiceDate | date:'longDate' }}</div>
      <div><strong>Customer Number</strong>: {{ order.accountId }}</div>
    </div>
  </div>

  <hr />

  <h3 class="my-5">Total: {{ order.totalPrice | scrMoney }}
    <span style="color: black; font-size: 1.5rem; margin-left: 3rem;">To be paid in monthly installments.</span>
  </h3>

  <hr />

  <h2 class="mt-5">Short Codes in Order</h2>

  <table class="table invoice-table mt-3">
    <thead>
      <th>Line</th>
      <th>Description</th>
      <th>Short Code</th>
      <th>Start Date</th>
      <th>End Date</th>
      <th class="money">List Price</th>
      <th i18n *ngIf="hasDiscount" class="money">Discount</th>
      <th class="money">Amount</th>
    </thead>
    <tbody>
      <tr *ngFor="let lease of order.lines || order.leases || []; let i=index">
        <td>{{ i+1 }}</td>
        <td>{{ lease.description }}</td>
        <td>{{ lease.scId }}</td>
        <td>{{ lease.startDate | scrDate }}</td>
        <td>{{ lease.endDate | scrDate }}</td>
        <td class="money">{{ lease.listPrice | scrMoney }}</td>
        <td *ngIf="hasDiscount" class="money">
          <div *ngFor="let discount of lease.discountList">
            {{ discount.displayName }}
          </div>
          <div *ngIf="lease.discountAmount" class="money">
            ({{ lease.discountAmount | scrMoney }})
          </div>
        </td>
        <td class="money">{{ lease.price | scrMoney }}</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td *ngIf="hasDiscount"></td>
        <td><strong>Total:</strong></td>
        <td class="money">{{ order.totalPrice | scrMoney }}</td>
      </tr>
    </tfoot>
  </table>
</div>
<footer *ngIf="config" class="mt-5">
  For billing inquiries please call <strong>{{config.customerSupportPhone}}</strong>
  or send an email to <strong><a class="link" href="mailto: {{config.customerSupportEmail}}">{{config.customerSupportEmail}}</a></strong>.
</footer>